<template>
    <div class="pb-5">
        <data-table ref="news"
                    :api-route="backendApiRoute"
                    :api-view-set="table.apiViewSet"
                    :name="table.name"
                    :columns="table.columns"
                    :search="table.search"
                    :filters="table.filters ? table.filters : []"
                    :actions="table.actions"
                    :orderings="table.orderings"
                    :initial-orderings="table.initialOrderings"
                    :row-actions="table.rowActions"
                    :key="table.key">
        </data-table>
    </div>
</template>

<script>
import DataTable from "@/components/Table/DataTable";
import {mapGetters} from "vuex";
import api from "@/api";
import actions from "@/components/Table/actions";
import {Municipality} from "@/pages/AppPages/Catalogs/Municipality/municipality";
import {Breed} from "@/pages/AppPages/Catalogs/Animals/breed";
import {News} from "@/pages/AppPages/News/news";
export default {
    name: "NewsList",
    components: {DataTable},
    computed: {
        ...mapGetters(['ability', 'isSuperuser', 'isInController', 'isMunicipalController']),
        backendApiRoute() { return api.news.default.list() },
    },
    data() {
        return {
            table: {
                name: 'news-table',
                apiViewSet: api.news.default,
                key: 'news-table',
                search: true,
                columns: [
                    { name: 'author_organization_object', 'title': 'Автор',
                            cellComponentName: 'NewsAuthorCell',
                            cellComponentPath: 'src/pages/DataTableCells/'},
                    { name: 'status', 'title': 'Статус',
                            cellComponentName: 'NewsStatusCell',
                            cellComponentPath: 'src/pages/DataTableCells/'},
                    {
                        name: 'title',
                        title:  'Заголовок',
                        alwaysVisible: true,
                        to: {
                            idColumn: 'id',
                            routeName: 'newsDetail',
                            prependWithN: false
                        }
                    },
                    { name: 'has_files', 'title': 'Файлы',
                            extraProps: {iconYes: 'file-earmark-richtext', iconNo: null, iconYesColor: 'info', iconNoColor: null},
                            cellComponentName: 'BooleanCell',
                            cellComponentPath: 'src/pages/DataTableCells/'},
                    { name: 'created_at', 'title': 'Создано',
                            cellComponentName: 'DateTimeCell',
                            cellComponentPath: 'src/pages/DataTableCells/'},
                    { name: 'publication_date', 'title': 'Дата публикации',
                            cellComponentName: 'DateTimeCell',
                            cellComponentPath: 'src/pages/DataTableCells/'},
                ],
                orderings: [
                    'title',
                    { 'author_organization_object': 'created_by__organization_id' },
                    { 'has_files': 'files_count' },
                    'created_at',
                    'publication_date',
                    'status'
                ],
                actions: [],
                rowActions: [],
                filters: [
                    { title: 'Статус', name: 'status', source: api.news.status.list() },
                    { title: 'Создана', name: 'created_at', type: 'dateFromTo' },
                    { title: 'Опубликована', name: 'publication_date', type: 'dateFromTo' },
                    { title: 'Есть фото', name: 'has_photos', type: 'boolean' },
                    { title: 'Есть видео', name: 'has_video', type: 'boolean' },
                    { title: 'Есть документы', name: 'has_docs', type: 'boolean' },
                ],
                initialOrderings: { created_at: 2 }
            }
        }
    },
    mounted() {

        if (this.isSuperuser || this.isInController && !this.isMunicipalController) {
            this.table.filters.unshift({ title: 'Автор', name: 'author', source: api.news.authors.list(), hasSearch: true })
        }

        this.table.actions.push(
            actions.create(() => {
                    this.$router.push({name: 'newsCreate'})
                }, this.ability.can('create', 'News')
            )
        );

        if (this.ability.can('destroy', 'News')) {
            this.table.rowActions.push(
                new actions.objectDelete(News))
        }

    }

}
</script>

<style scoped>

</style>